/**
 * Манифест управления буфером (#2204) — жилец ОБОИХ домов.
 *
 * ДВА ДОМА, ОДИН МАНИФЕСТ. Слово владельца 27.08: буфер виден и из библиотеки звуков, и из
 * журнала — там и там человек упирается в один и тот же предел. Второго манифеста заводить
 * нельзя: два описания одного жильца разойдутся, и сайдбары двух страниц начнут звать его
 * по-разному. Имя, версия и описание живут здесь; страницы берут их отсюда.
 *
 * РОД — `showcase`, и это не формальность. Витрина показывает, что уйдёт, и ждёт слова
 * человека; само удаление витриной НЕ является и идёт отдельной ручкой сервера
 * (`…/buffer-cleanup/execute`), принимающей поимённый список. Разделение прямое: цена
 * ошибки у показа и у стирания разная, и контракт обязан это различать.
 *
 * ДОМ — `background-media/collections`: буфер есть набор, живёт там, где лежит звук.
 * Журнальная страница показывает того же жильца того же дома — не заводит своего.
 *
 * ПОЧЕМУ МАНИФЕСТ ЛЕЖИТ ЗДЕСЬ, А НЕ У ОБРАБОТЧИКОВ. Ревью #2211 нашло дубль: манифест был у
 * `plugin-handlers`, а страница объявляла жильца инлайном — два описания одного плагина уже
 * разошлись между собой. Носитель должен быть один и доступен обоим потребителям; кабинет
 * зависит от этого пакета и не должен тянуть обработчики (meyda, декодер wav) ради строки.
 * Сервер берёт манифест отсюда же реэкспортом.
 */
import type { PluginId, ShowcaseManifest } from '@membrana/plugin-contracts';

export const BUFFER_MANAGER_MANIFEST: ShowcaseManifest = {
  id: 'membrana.showcase.buffer-manager' as PluginId,
  version: '0.1.0',
  kind: 'showcase',
  mountTarget: 'background-media/collections',
  triggers: ['collections.collection_created'],
  displayForm: 'table',
  description: 'Управление буфером: сколько занято и что уйдёт при уборке — показать и ждать слова',
};

export const BUFFER_MANAGER_ID = BUFFER_MANAGER_MANIFEST.id;
